@if (state().status === "loading") {
  <!-- Loading state -->
  <div class="app app__loader">
    <div class="app__content">
      <div class="app__spinner">
        <mat-spinner diameter="60" />
      </div>
      <h2 class="app__title">Cargando tu tienda...</h2>
      <p class="app__description">
        Preparando la mejor experiencia de compra para ti
      </p>
      <div class="app__dots">
        <span class="app__dot"></span>
        <span class="app__dot"></span>
        <span class="app__dot"></span>
      </div>
    </div>
  </div>
} @else if (state().status === "error") {
  <!-- Error state -->
  <div class="app app__error">
    <div class="app__icon">
      <mat-icon>error_outline</mat-icon>
    </div>
    <h2 class="app__title">No pudimos cargar la aplicación</h2>
    <p class="app__description">
      {{ state().error || "Ocurrió un problema al inicializar la tienda." }}
    </p>
    <p class="app__description">Esto puede deberse a:</p>
    <ul class="app__list">
      <li class="app__list-item">Problemas de conexión a internet</li>
      <li class="app__list-item">Servicios temporalmente no disponibles</li>
      <li class="app__list-item">Configuración de la tienda</li>
    </ul>
    <p class="app__suggestion">
      Por favor, verifica tu conexión e intenta nuevamente.
    </p>
    <button matButton="elevated" (click)="retry()" class="app__button">
      <mat-icon>refresh</mat-icon>
      Intentar nuevamente
    </button>
  </div>
} @else if (state().status === "ready") {
  <!-- App state -->
  <router-outlet />
}
